/* Keep mobile size changes at the shopper's current vertical position.
 * Dawn's product-info updateMedia calls setActiveMedia, which otherwise scrolls
 * the window up to the gallery. Explicit gallery navigation stays native.
 */
(() => {
  document.addEventListener('change', (event) => {
    const picker = event.target.closest?.('variant-selects');
    const product = picker?.closest('product-info');
    if (product) {
      product.customMobileSizeSelection = /^(?:options\[)?size(?:\]|-|$)/i.test(event.target.name || '');
    }
  }, true);

  customElements.whenDefined('product-info').then(() => {
    const prototype = customElements.get('product-info').prototype;
    if (prototype.customMobileVariantScrollInstalled) return;
    const nativeUpdateMedia = prototype.updateMedia;
    if (typeof nativeUpdateMedia !== 'function') return;

    function activateVariantMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`)
        || this.elements.viewer.querySelector('[data-media-id]');
      if (!activeMedia) return;
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((item) => {
        item.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        if (activeMedia.parentElement.firstElementChild !== activeMedia) {
          activeMedia.parentElement.prepend(activeMedia);
        }
        const thumbnail = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);
        if (thumbnail && thumbnail.parentElement.firstElementChild !== thumbnail) {
          thumbnail.parentElement.prepend(thumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
      });
      this.playActiveMedia(activeMedia);
      if (!this.elements.thumbnails) return;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      if (!thumbnail) return;
      this.setActiveThumbnail(thumbnail);
      this.announceLiveRegion(activeMedia, thumbnail.dataset.mediaPosition);
    }

    prototype.updateMedia = function (...args) {
      const gallery = this.querySelector('media-gallery');
      if (!this.customMobileSizeSelection || window.matchMedia('(min-width: 750px)').matches
        || !gallery?.elements?.viewer) {
        return nativeUpdateMedia.apply(this, args);
      }
      // Only the synchronous variant-update call uses this replacement. Gallery
      // arrows, thumbnails, swiping, modals and desktop retain Dawn's own method.
      const descriptor = Object.getOwnPropertyDescriptor(gallery, 'setActiveMedia');
      gallery.setActiveMedia = activateVariantMedia;
      try {
        return nativeUpdateMedia.apply(this, args);
      } finally {
        if (descriptor) Object.defineProperty(gallery, 'setActiveMedia', descriptor);
        else delete gallery.setActiveMedia;
      }
    };
    prototype.customMobileVariantScrollInstalled = true;
  });
})();
